var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"loading":_vm.loading,"color":"grey","outline":"","small":_vm.small},on:{"click":_vm.exportxlsx}},[_c('em',{staticClass:"fas fa-file-export"}),_vm._v("\n   \n  "+_vm._s(_vm.$t('export'))+" \n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d50c12","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/exportxlsx.vue
// module id = null
// module chunks = 